import bidsApi from './shared/resource/bids';

function addBulkBids({ bids, campaignId }) {
  const transformedBids = bids.map(({ keyword, priceOffer, matchType }) => ({
    query: keyword,
    matchingType: matchType,
    priceOffer,
  }));

  return bidsApi.addBulkBids({
    campaignId,
    bids: transformedBids,
    referrer: 'bulk-import',
  });
}

export default {
  addBulkBids,
};
